import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useRef } from 'react';
import ReactDOM from 'react-dom';
import ToolbarWrapper from './ToolbarWrapper';
import ddt from '@wix/da-ddt';
const PORTAL_ELEMENT_DEFAULT_ID = 'inline-texttools-portal';
const Portal = ({ children, portalId })=>{
    const containerId = portalId || PORTAL_ELEMENT_DEFAULT_ID;
    const container = useRef(document.getElementById(containerId));
    if (!container.current) {
        const el = document.createElement('div');
        el.id = containerId;
        document.body.appendChild(el);
        container.current = el;
    }
    return /*#__PURE__*/ ReactDOM.createPortal(children, container.current);
};
const PortalWrapper = (_param)=>{
    var { children, refCallback, portalId, menuWidth } = _param, props = _object_without_properties(_param, [
        "children",
        "refCallback",
        "portalId",
        "menuWidth"
    ]);
    const style = _object_spread_props(_object_spread({}, props.style), {
        zIndex: 9999999
    });
    ddt.log('editor-menu', 'Apply menu pos hack', props.style);
    // wix editors hack that waited a tick before using selection state to calculate the
    // selection position stopped working. This gets the raw selection from the browser
    // and positions the portal manually overriding that faulty calculation. As we are
    // using portal we also don't need to worry about the relative positioning fixes.
    try {
        const selection = document.getSelection();
        if (!(selection === null || selection === void 0 ? void 0 : selection.isCollapsed)) {
            const selRange = selection === null || selection === void 0 ? void 0 : selection.getRangeAt(0);
            const box = selRange === null || selRange === void 0 ? void 0 : selRange.getBoundingClientRect();
            const clientWidth = document.documentElement.clientWidth;
            const commonParent = selRange === null || selRange === void 0 ? void 0 : selRange.commonAncestorContainer.parentElement;
            const editor = commonParent === null || commonParent === void 0 ? void 0 : commonParent.closest('.DraftEditor-root');
            ddt.log('editor-menu', 'Parent editor', editor);
            if (editor) {
                var _box_top;
                const calcTop = ((_box_top = box === null || box === void 0 ? void 0 : box.top) !== null && _box_top !== void 0 ? _box_top : 0) + window.scrollY - 48;
                var _box_left;
                const calcLeft = ((_box_left = box === null || box === void 0 ? void 0 : box.left) !== null && _box_left !== void 0 ? _box_left : 0) + window.screenX;
                style['--offset-top'] = `${calcTop}px`;
                style['--offset-left'] = `${calcLeft}px`;
                // handle hanging off right screen edge
                if (calcLeft + menuWidth > clientWidth) {
                    const diff = calcLeft + menuWidth + 10 - clientWidth;
                    style['--offset-left'] = `${calcLeft - diff}px`;
                }
                const query = editor.querySelectorAll('div[data-focused="1"]');
                const focusBlock = Array.from(query)[0];
                if (focusBlock) {
                    // When selecting atomics it pushes the selection outside the block area
                    // move the menu back to the start of the focused block (which is always
                    // the top most)
                    const focusBlockRect = focusBlock.getBoundingClientRect();
                    ddt.log('editor-menu', 'Menu hack focus block', focusBlockRect);
                    if (calcLeft < focusBlockRect.left) {
                        var _focusBlockRect_left;
                        style['--offset-left'] = `${(_focusBlockRect_left = focusBlockRect.left) !== null && _focusBlockRect_left !== void 0 ? _focusBlockRect_left : 0}px`;
                    }
                    // Handle select all making the menu be off screen
                    const observer = new IntersectionObserver((entries, opts)=>{
                        entries.forEach((entry)=>{
                            if (!entry.isIntersecting) {
                                ddt.log('editor-menu', 'Scrolling to selection', entry);
                                focusBlock.scrollIntoView();
                            }
                            observer.unobserve(entry.target);
                        });
                    });
                    observer.observe(focusBlock);
                }
                ddt.log('editor-menu', 'Menu pos hack result', style, box, selRange);
            }
        }
    } catch (e) {
        ddt.log('editor-menu', 'Pos hack fail', e);
    }
    return /*#__PURE__*/ React.createElement(Portal, {
        portalId: portalId
    }, /*#__PURE__*/ React.createElement(ToolbarWrapper, null, /*#__PURE__*/ React.createElement("div", {
        dir: ""
    }, /*#__PURE__*/ React.createElement("div", _object_spread_props(_object_spread({}, props), {
        ref: refCallback,
        style: style
    }), children))));
};
export default (({ portalId, menuWidth })=>()=>{
        const Component = ()=>(props)=>/*#__PURE__*/ React.createElement(PortalWrapper, _object_spread({
                    portalId: portalId,
                    menuWidth: menuWidth
                }, props));
        return {
            desktop: Component,
            mobile: {
                ios: Component,
                android: Component
            }
        };
    });

//# sourceMappingURL=PortalDecorator.js.map